<template>
    <Container class="px-[18px]">
        <div>
            <h2 class="text-primary-500 leading-[48px] text-[20px] md:text-[36px] font-[600] md:font-[700]">
                {{ heading }}
            </h2>
        </div>
    </Container>
</template>

<script>
import Container from '../../../Layouts/Container'

export default {
    components: {
        Container,
    },
    props: {
        heading: {
            type: String,
            default: 'Meet our Amazing Partner'
        }
    }
}
</script>
